(function(window, app, overwatch) {

    function mq(val) {
        return window.matchMedia("(min-width: " + val +")").matches;
    }

    var open = {
		init: function init() {
            var mobileMode = !mq('640px');

            var $changeRegion = $('[data-js="change-region"]');

            $changeRegion.on('change', function() {
                var c = $(this).val();
                $('.js-region-block').addClass('is-hidden');
                $('.js-region-block-' + c).removeClass('is-hidden');
            });

            $changeRegion.select2({
                placeholder: 'Select Your Region'
            });

            $changeRegion.on('select2:open', function() {
                if (mobileMode) {
                    const scrollTargetOffset = $changeRegion.offset().top - 48;
                    $('html, body').animate({
                        scrollTop: scrollTargetOffset,
                    });
                }
            });

            $(window).on('resize', function() {
                mobileMode = !mq('640px');
            });
		}
    }

	app.extend({ open: open });
}(window, window.app, window.overwatch));
